/*
  ANINA · submenu do cabeçalho e gaveta do celular.
  - <anina-mega>: troca o palco (perfumes ou trecho da curadoria) conforme o item sob o mouse ou o foco.
  - Gaveta do celular: mostra a quantidade de perfumes ao lado de cada coleção e acrescenta,
    no fim da gaveta, o atalho para o guia olfativo e o WhatsApp (conteúdo vem do
    <template id="anina-gaveta-rodape"> em snippets/anina-menu-estilos.liquid).
*/

class AninaMega extends HTMLElement {
  connectedCallback() {
    this.itens = [...this.querySelectorAll('.anina-mega__item')];
    this.paineis = [...this.querySelectorAll('.anina-mega__painel')];
    this.atual = 0;
    this.aoEntrar = (evento) => {
      const item = evento.target.closest('.anina-mega__item');
      if (!item) return;
      clearTimeout(this.espera);
      const indice = Number(item.dataset.indice);
      if (evento.type === 'focusin') {
        this.ativar(indice);
      } else {
        // Pequena espera para o palco não piscar quando o mouse só atravessa a lista.
        this.espera = setTimeout(() => this.ativar(indice), 70);
      }
    };
    this.aoSair = () => clearTimeout(this.espera);
    this.addEventListener('pointerover', this.aoEntrar);
    this.addEventListener('focusin', this.aoEntrar);
    this.addEventListener('pointerleave', this.aoSair);
  }

  disconnectedCallback() {
    clearTimeout(this.espera);
    this.removeEventListener('pointerover', this.aoEntrar);
    this.removeEventListener('focusin', this.aoEntrar);
    this.removeEventListener('pointerleave', this.aoSair);
  }

  ativar(indice) {
    if (indice === this.atual || Number.isNaN(indice)) return;
    this.atual = indice;
    this.itens.forEach((item, i) => item.classList.toggle('is-ativo', i === indice));
    this.paineis.forEach((painel, i) => painel.classList.toggle('is-ativo', i === indice));
  }
}

if (!customElements.get('anina-mega')) customElements.define('anina-mega', AninaMega);

function caminho(href) {
  try {
    return new URL(href, location.href).pathname;
  } catch (erro) {
    return '';
  }
}

function melhorarGaveta() {
  const quantidades = new Map();
  document.querySelectorAll('.anina-mega__item[data-qtd]').forEach((item) => {
    quantidades.set(caminho(item.href), item.dataset.qtd);
  });

  document.querySelectorAll('.menu-drawer__menu-item--child').forEach((link) => {
    if (link.querySelector('.anina-gaveta__qtd')) return;
    const qtd = quantidades.get(caminho(link.href));
    if (!qtd) return;
    const span = document.createElement('span');
    span.className = 'anina-gaveta__qtd';
    span.textContent = qtd;
    link.append(span);
  });

  const gaveta = document.querySelector('.menu-drawer');
  const modelo = document.getElementById('anina-gaveta-rodape');
  if (gaveta && modelo && !gaveta.querySelector('.anina-gaveta__rodape')) {
    const conteudo = modelo.content.cloneNode(true);
    const navegacao = gaveta.querySelector('.menu-drawer__navigation');
    if (navegacao) {
      navegacao.after(conteudo);
    } else {
      gaveta.append(conteudo);
    }
  }
}

if (!window.aninaGavetaPronta) {
  window.aninaGavetaPronta = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', melhorarGaveta, { once: true });
  } else {
    melhorarGaveta();
  }

  // O tema pode redesenhar o cabeçalho; ao abrir a gaveta, garante que tudo está lá.
  document.addEventListener(
    'toggle',
    (evento) => {
      if (evento.target instanceof HTMLDetailsElement && evento.target.matches('.menu-drawer-container') && evento.target.open) {
        melhorarGaveta();
      }
    },
    true
  );

  // Atalho para o guia na própria home: fecha a gaveta antes de rolar até a seção.
  document.addEventListener('click', (evento) => {
    const link = evento.target.closest('.anina-gaveta__rodape a[href*="#"]');
    if (!link || caminho(link.href) !== location.pathname) return;
    const gaveta = link.closest('.menu-drawer-container');
    gaveta?.querySelector('summary')?.click();
  });
}